import React from 'react';
import style from './Services.module.css';
import { ornament2, OurServicesBg } from '../../assets';
import OurServicesCard from '../../components/OurServicesCard';
import SkillSection from '../SkillSection';
import TopTalentCard from '../../components/TopTalentCard';
import { serviceIcon1, beforePanel } from '../../assets';
import ATSImage from '../../assets/ATSImage.png';
import FMImage from '../../assets/FMImage.png';
import Header from '../../components/Header';
import HeaderMobile from "../../components/HeaderMobile";

function Services() {

    const servicesArray = [

        {
            icon: serviceIcon1,
            heading: "Full-Cycle Recruitment",
            content: "End-to-end recruitment excellence powered by AI and human expertise. We manage everything from sourcing to onboarding, ensuring quality hires aligned with your business goals.",
            bgColor: "white",
            bgColorForIcon: "#FF9900"
        },
        {
            icon: serviceIcon1,
            heading: "Talent Management",
            content: "Comprehensive talent strategies that optimize workforce potential. From performance management to succession planning, we help you nurture and retain top talent.",
            bgColor: "white",
            bgColorForIcon: "#FF9900"
        },
        {
            icon: serviceIcon1,
            heading: "HR Consulting",
            content: "Expert guidance on HR best practices, compliance, and organizational development. We help you build robust HR frameworks that drive business success.",
            bgColor: "white",
            bgColorForIcon: "#FF9900"
        },
        {
            icon: serviceIcon1,
            heading: "Permanent Staffing Solutions",
            content: "Strategic permanent hiring solutions that focus on long-term fit. We combine industry expertise with advanced analytics to find candidates who will grow with your organization.",
            // bgColor: "#F4F4F4",
            bgColorForIcon: "#FF9900"
        },
        {
            icon: serviceIcon1,
            heading: "ATS",
            content: "A cutting-edge applicant tracking system designed for modern hiring needs. Seamlessly manage your entire recruitment workflow with our intuitive, feature-rich platform.",
            // bgColor: "#F4F4F4"   ,
            bgColorForIcon: "#FF9900"     
        },
        {
            icon: serviceIcon1,
            heading: "FoxMatrix",
            content: "Our proprietary AI-powered hiring platform that streamlines recruitment through smart matching, automated screening, and advanced analytics. Experience faster, more accurate hiring decisions.",
            // bgColor: "#F4F4F4"  ,
            bgColorForIcon: "#FF9900"          
        }
    ]

    return (
        <>

        <HeaderMobile />
        <div className={style.dashboard}>
            
            <Header />
            
            <img src={OurServicesBg} alt="" />
            
            <div className={style.content_container}>
                <p data-aos="fade-up" data-aos-duration="2000" data-aos-delay="0">Transforming Talent Acquisition & Management</p>
                <p data-aos="fade-up" data-aos-duration="2000" data-aos-delay="250">We provide innovative HR solutions powered by technology to streamline your hiring process and enhance workforce management.</p>
            </div>

        </div> 

        <div className={style.OurServices_container}>
            <section>
                <img src={ornament2} alt="..." />
                <h1 data-aos="fade-up" data-aos-duraion="1000" data-aos-delay="1"> Our Services</h1>
                <img src={ornament2} alt="..." />
            </section>
            <OurServicesCard data-aos="fade-up" data-aos-duraion="1000" data-aos-delay="1" data={servicesArray[0]} />
            <OurServicesCard data-aos="fade-up" data-aos-duraion="1000" data-aos-delay="1" data={servicesArray[1]} />
            <OurServicesCard data-aos="fade-up" data-aos-duraion="1000" data-aos-delay="2" data={servicesArray[2]} />
            <OurServicesCard data-aos="fade-up" data-aos-duraion="1000" data-aos-delay="3" data={servicesArray[3]} />
            <OurServicesCard data-aos="fade-up" data-aos-duraion="1000" data-aos-delay="3" data={servicesArray[4]} />
            <OurServicesCard data-aos="fade-up" data-aos-duraion="1000" data-aos-delay="3" data={servicesArray[5]} />
        </div>

        <SkillSection allowOuterShadow={false} />


        <div className={style.StaffingSolutionsContainer_outer}>

            <div className={style.StaffingSolutionsContainer}>
                <h1>From Inquiry to Impact: Navigating Our Staffing Solutions</h1>
                <section>
                    <div><img data-aos="flip-left" data-aos-duration="1000" data-aos-offset="10" src={ATSImage} alt="ATSImage" /></div>
                    <div>
                        <button>Applicant Tracking System</button>
                        <p className={style.staffing_heading_common}>NuFolks ATS</p>
                        <p className={style.staffing_para_common} style={{textAlign: "right"}}>NuFolks' home-grown, full-lifecycle Applicant Tracking System (ATS) ensures a near-perfect hiring process. Over time, feedback from recruiters and clients has helped refine and mature the tool, making it more effective and user-friendly. The ATS seamlessly integrates with clients' existing systems, allowing for a smooth flow of candidate data. Designed for efficiency and practicality, NuFolks ATS is available for clients looking to transition to a more advanced and reliable recruitment solution.</p>
                    </div>
                </section>
                <section>
                    <div>
                        <button>FoxMatrix</button>
                        <p className={style.staffing_heading_common}>Interviewing Platform, with Real Interviewers</p>
                        <p className={style.staffing_para_common} >FoxMatrix enables fast and reliable candidate interviews by real interviewers. It follows an efficient screening process—10:3 sources 10 CVs, filters out 7, and passes 3 to the client, while 10:3:1 further shortlists 1 after interviews. This streamlined approach ensures only the best candidates reach the client.</p>
                    </div>
                    <div><img data-aos="flip-right" data-aos-duration="1000" data-aos-offset="10" src={FMImage} alt="FMImage" /></div>
                </section>
            </div>

        </div>


        <div className={style.TopTalent_outer_Container}>
            <TopTalentCard heading="Let’s Build Careers, Together" content="Looking for growth-driven opportunities or the right talent to elevate your team? Drop your CV or hire top-notch talent today." cardBGColor="rgb(250 236 222)" hColor="black" pColor= "#12151D" />
        </div> 
        </>
    )
}

export default Services